/**
 * @generated SignedSource<<52de87b56e2bb32df43481ea989439e2>>
 * @relayHash 139fae60f7b439ca7bbb2ae98032bdd1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3e236e8096731e034049b4c120abe65ae117a620f5e0a8023028cb0064f1b65e

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CardCoverPageContentQuery$variables = {
  boardId: string;
};
export type CardCoverPageContentQuery$data = {
  readonly boardScope: {
    readonly board: {
      readonly " $fragmentSpreads": FragmentRefs<"CardCoverToggle" | "CardPreview">;
    };
  };
};
export type CardCoverPageContentQuery = {
  response: CardCoverPageContentQuery$data;
  variables: CardCoverPageContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "boardId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "boardId",
    "variableName": "boardId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CardCoverPageContentQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "concreteType": "BoardScope",
          "kind": "LinkedField",
          "name": "boardScope",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "concreteType": "SoftwareBoard",
                "kind": "LinkedField",
                "name": "board",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "CardCoverToggle"
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "CardPreview"
                  }
                ]
              },
              "action": "THROW",
              "path": "boardScope.board"
            }
          ]
        },
        "action": "THROW",
        "path": "boardScope"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CardCoverPageContentQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "BoardScope",
        "kind": "LinkedField",
        "name": "boardScope",
        "plural": false,
        "selections": [
          {
            "concreteType": "SoftwareBoard",
            "kind": "LinkedField",
            "name": "board",
            "plural": false,
            "selections": [
              {
                "concreteType": "CardMediaConfig",
                "kind": "LinkedField",
                "name": "cardMedia",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "enabled"
                  }
                ]
              },
              (v2/*: any*/)
            ]
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "3e236e8096731e034049b4c120abe65ae117a620f5e0a8023028cb0064f1b65e",
    "metadata": {},
    "name": "CardCoverPageContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d86a54c6a42dc0ffbbcab92ac932cf91";

export default node;
